export default function CStructAccess() {
  return <h2>C Struct Access</h2>;
}
